export class SearchRuToursModel {
  recaptchaToken?: string;
  countryCode: string;
  checkIn: string;
  searchToken?: string;
  allCountries?: boolean;
  allDates?: boolean;

  constructor(params?: URLSearchParams) {
    if (params) {
      const data = Object.fromEntries(params.entries());
      this.allDates = data.allDates === 'true';
      this.allCountries = data.allCountries === 'true';
      this.checkIn = data.checkIn;
      this.countryCode = data.countryCode;
    } else {
      this.countryCode = 'all';
      this.checkIn = 'all';
    }
  }
}
